"use client";

import { useState } from "react";
import Link from "next/link";

export type NavItem = { href: string; label: string; kiemelt: boolean };

export function PublicHeader({ navItems }: { navItems: NavItem[] }) {
  const [open, setOpen] = useState(false);
  const normalItems = navItems.filter((item) => !item.kiemelt);
  const kiemeltItem = navItems.find((item) => item.kiemelt);

  return (
    <>
      <div className="site-topbar">
        <div className="site-topbar-inner">
          <a href="mailto:kapcsolat@fkmenergy.hu">kapcsolat@fkmenergy.hu</a>
          <a href="tel:+36701694979">+36 70 169-4979</a>
        </div>
      </div>
      <header className="site-header">
        <div className="site-header-inner">
          <Link href="/" className="site-logo" onClick={() => setOpen(false)}>
            <img src="/logo/fkm-logo-kompakt-atlatszo.png" alt="FKM Energy" />
          </Link>
          <nav className="site-nav" data-open={open}>
            {normalItems.map((item) => (
              <Link key={item.href} href={item.href} onClick={() => setOpen(false)}>
                {item.label}
              </Link>
            ))}
            {kiemeltItem && (
              <Link href={kiemeltItem.href} className="cta" onClick={() => setOpen(false)}>
                {kiemeltItem.label}
              </Link>
            )}
          </nav>
          <button
            type="button"
            className="menu-toggle"
            aria-label={open ? "Menü bezárása" : "Menü megnyitása"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <span />
          </button>
        </div>
      </header>
    </>
  );
}
